import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from '@angular/forms';

@Directive({
    selector: '[appTinNumberValidation]'
})
export class TinNumberValidationDirective {

    constructor() { }

}

export function tinNumberValidator(form: FormGroup): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control && control.value) {
            let value: string = control.value;
            let numberRegex = new RegExp('^[0-9]*$');
            let stringRegex = new RegExp('^[A-Z]*$');
            let alphaNumericRegex = new RegExp('^[0-9A-Z]*$');
            let zeroRegex = new RegExp('^[1-9]*$');
            let zRegex = new RegExp('^[Z]*$');

            let specialChar = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
            if (!specialChar.test(value)) {
                if (value.length >= 2) {
                    if (!numberRegex.test(value.substr(0, 2))) {
                        return { 'tinValidation': { value: control.value } };
                    } else {
                        if (value.length >= 5) {
                            if (!stringRegex.test(value.substr(2, 3))) {
                                return { 'tinValidation': { value: control.value } };
                            } else {
                                if (value.length >= 6) {
                                    let regExp = new RegExp('^[CPHFATBLJGcphfatblj]*$');
                                    if (!regExp.test(value.substr(5, 1))) {
                                        return { 'tinValidation': { value: control.value } };
                                    } else {
                                        if (value.length >= 7) {
                                            if (!stringRegex.test(value.substr(6, 1))) {
                                                return { 'tinValidation': { value: control.value } };
                                            } else {
                                                if (value.length >= 11) {
                                                    if (!numberRegex.test(value.substr(7, 4))) {
                                                        return { 'tinValidation': { value: control.value } };
                                                    } else {
                                                        if (value.length >= 12) {
                                                            if (!alphaNumericRegex.test(value.substr(11, 1))) {
                                                                return { 'tinValidation': { value: control.value } };
                                                            } else {
                                                                if (value.length >= 13) {
                                                                    if (!zeroRegex.test(value.substr(12, 1))) {
                                                                        return { 'tinValidation': { value: control.value } };
                                                                    } else {
                                                                        if (value.length >= 14) {
                                                                            if (!zRegex.test(value.substr(13, 1))) {
                                                                                return { 'tinValidation': { value: control.value } };
                                                                            } else {
                                                                                if (value.length >= 15) {
                                                                                    if (!alphaNumericRegex.test(value.substr(14, 1))) {
                                                                                        return { 'tinValidation': { value: control.value } };
                                                                                    } else {
                                                                                        return null;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    // return { 'panMaxValidation': {value: control.value} }
                    return null;
                }
            } else {
                return { 'specialValidation': { value: control.value } };
            }
        }
    };
}

export function confirmTinValidation(form: FormGroup): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control && control.value && form) {
            let tinNoValue = form.controls['gstin'].value;
            if (tinNoValue) {
                if (tinNoValue !== control.value) {
                    return { 'confirmTINValidation': { value: control.value } };
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } else {
            return null;
        }
    };
}
